<script lang="ts">
  export let text: string;
</script>

<p class="text-center-- font-normal text-sm">{text}</p>
